import React from "react";
import AwardAmountRange from "./AwardAmountRange";
import AwardAmountListOfValues from "./AwardAmountListOfValues";

export default function AwardAmountControl(props) {
    const program = props.program;
    const budgetList = props.budgetList;
    const recipients = props.recipients;
    const callback = props.updateCallback;

    return (
        <div>
            {Object.keys(budgetList).length > 0 &&
                <>
                    {program.awardAmountPolicy?.range &&
                        <AwardAmountRange program={program} budgetList={budgetList}
                        recipients={recipients} callback={callback}
                    />}
                    {program.awardAmountPolicy?.values?.length && program.awardAmountPolicy?.values.length > 0 &&
                        <AwardAmountListOfValues program={program} budgetList={budgetList}
                        recipients={recipients} callback={callback} 
                    />}
                </>

            }
        </div >
    )
}